import { Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { ACCOUNT_TYPE } from './utils/Account_Type';
import HomePage from "./pages/Home/HomePage"
import AuthPage from "./components/core/AuthPage"
import BillingAndPlan from "./pages/Organization/BillingAndPlan"
// import BillingAndPlanManager from "./pages/Organization/BillingAndPlanManager" //Need to Check
import BillingAndPlanManager from "./components/Organization/Org_Dashboard/TransactionManagement"
import Header from './components/HeaderFooter/Header';
import Dashboard from './pages/Organization/Org_Dashboard';
import ManagerDasboard from './pages/Organization/ManagerDashboard';
import UserDashboard from './pages/employee/Dashboard/UserDashboard';
import Contact from './pages/Home/ContactPage';
import About from './pages/Home/About';
import NotFound from './pages/Home/NotFound';
import Product from './pages/Home/Product'
import HelpSection from './pages/Home/HelpSection';
import SendFeedback from './pages/Home/SendFeedback'
import OpenRoute from './components/core/OpenRoutes';
import TermsAndPrivacyCompact from './pages/Home/TermAndPrivancy';
import WatchDemo from './pages/Home/Watch_Demo';
import PaymentPageBiometic from './pages/Home/BiometricOrder';
import SoftwarePlanPayment from './pages/Home/SoftwarePlan'
import Help from './pages/Home/Help';
// Session Checking Token. Is Valid Or Not.
import {isTokenExpired,Logout} from './services/oprations/Auth'
import ToastProvider from './components/Toast';
import { ThemeProvider } from './Context/themeContext';

function App() {
  const {user} = useSelector((state)=>state.profile)
  const dispatch = useDispatch()
  
  if (true) {
// console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  toast.success = () => {};
  toast.error = () => {};
  toast.info = () => {};
  toast.warn = () => {};
  }
  
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (token && isTokenExpired(token)) {
      dispatch(Logout());
    }
  }, [dispatch]);
  // Parse user if it's a string
  const userData = typeof user === 'string' ? JSON.parse(user) : user;

  return (
    <ThemeProvider>
      <ToastProvider>
        <div>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<OpenRoute><AuthPage /></OpenRoute>} />
            <Route path='/contact' element = {<Contact/>}/>
            <Route path='/about' element = {<About/>}/>
            <Route path='/help' element = {<Help/>}/>
            <Route path='/product' element = {<Product/>}/>
            <Route path='/purchase-biometric/hardware' element = {<PaymentPageBiometic/>}/>
            <Route path='/purchase-software/plan' element = {<SoftwarePlanPayment/>}/>
            <Route path='/help-section' element = {<HelpSection/>}/>
            <Route path='/send-feedback' element = {<SendFeedback/>}/>
            <Route path='/term-privacy' element = {<TermsAndPrivacyCompact/>}/>
            <Route path='/watch-demo' element = {<WatchDemo/>}/>
            {userData?.role === ACCOUNT_TYPE.ORGANIZATION &&  <Route path="/dashboard" element={<Dashboard />} />}
            {userData?.role === ACCOUNT_TYPE.ORGANIZATION && <Route path="/billing-plan" element={<BillingAndPlan />} />}
            {userData?.role === ACCOUNT_TYPE.MANAGER && <Route path="/billing-and-plan" element={<BillingAndPlanManager />} />}
            {userData?.role === ACCOUNT_TYPE.MANAGER && <Route path="/dashboard" element={<ManagerDasboard />} />}
            {userData?.role === ACCOUNT_TYPE.USER && <Route path="/dashboard" element={<UserDashboard />} />}
            <Route path='*' element ={<NotFound/>}/>
          </Routes>
        </div>
      </ToastProvider>  
    </ThemeProvider>  
  );
}

export default App;
